export const formatGross = (value) => {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatTime = (iso, timeZone) => {
  if (!iso) return '';
  const tzOpt = timeZone ? { timeZone } : {};
  return new Date(iso).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    ...tzOpt,
  });
};

export const formatDateLine = (iso, timeZone) => {
  if (!iso) return '—';
  const tzOpt = timeZone ? { timeZone } : {};
  return new Date(iso).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...tzOpt,
  });
};

export const formatEventTimes = (event, timeZone) => {
  const doors = formatTime(event.door_time, timeZone);
  const start = formatTime(event.event_date, timeZone);
  if (doors && start) return `Doors: ${doors} | Event Time: ${start}`;
  if (start) return `Event Time: ${start}`;
  if (doors) return `Doors: ${doors}`;
  return '';
};

export const formatSupportNames = (names) => {
  if (!names || names.length === 0) return null;
  if (names.length === 1) return `with ${names[0]}`;
  if (names.length === 2) return `with ${names[0]} & ${names[1]}`;
  return `with ${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`;
};
